/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    withStyles, Switch,
} from '@material-ui/core';
import {
    object, shape, string, func, bool,
} from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import AutoRenewalModal from './AutoRenewalModal';
import { setTokenLocalStorage } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    container: {
        marginTop: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    block: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelBox: {
        margin: '0px',
        width: '100px',
        display: 'flex',
        justifyContent: 'center',
    },
    iconRoot: {
        width: 48,
        height: 24,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(24px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 22,
        height: 22,
    },
    track: {
        borderRadius: 36 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    boldText: {
        fontWeight: 900,
        paddingBottom: '12px',
        textTransform: 'uppercase',

        [theme.breakpoints.up('md')]: {
            paddingBottom: '0',
        },
    },
    greenText: {
        fontWeight: 900,
        color: 'green',
        fontSize: '18px',
    },
    redText: {
        fontWeight: 900,
        color: 'red',
    },
    checkboxStyle: {
        marginLeft: '10px',
        marginRight: '5px',
    },
    checked: {},
    focusVisible: {},
});

const AutoRenewal = ({
    classes, userDetails, autoRenewalStatus, updateAutoRenewal, trackAutoRenewEvent,
}) => {
    const { email } = userDetails;
    const [autoRenewal, setAutoRenewal] = useState({
        checked: true,
    });
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setAutoRenewal({ checked: autoRenewalStatus });
    }, [autoRenewalStatus]);

    const toggleAutoRenewal = (event) => {
        setAutoRenewal({
            ...autoRenewal,
            [event.target.name]: event.target.checked,
        });
        // Toggle Off
        if (autoRenewal.checked === true) {
            setShowModal(autoRenewal.checked);
            trackAutoRenewEvent({
                eventCategory: 'account',
                eventAction: 'pp auto renew off switch click',
                eventLabel: 'passport',
            });
        }
        // Toggle Auto Renew On
        if (autoRenewal.checked === false) {
            updateAutoRenewal({ emailId: email, autoRenewFlag: true });
            trackAutoRenewEvent({
                eventCategory: 'account',
                eventAction: 'pp auto renew switched on',
                eventLabel: 'passport',
                eventValue: 1,
            });
            setTokenLocalStorage(true, 'refreshMetadata');
        }
    };

    // user decides not to turn off auto renewal
    const closeModal = () => {
        setAutoRenewal({
            checked: true,
        });
        setShowModal(false);
        trackAutoRenewEvent({
            eventCategory: 'account',
            eventAction: 'overlay closed',
            eventLabel: 'passport',
        });
    };
    return (
        <div className={classes.container}>
            <div className={classes.boldText}>
                <span>Auto Renew</span>
            </div>
            <div className={classes.block}>
                <FormControlLabel
                    data-test="auto-renew-test-btn"
                    className={classes.checkboxStyle}
                    control={(
                        <Switch
                            focusVisibleClassName={classes.focusVisible}
                            onChange={toggleAutoRenewal}
                            checked={autoRenewal.checked}
                            name="checked"
                            disableRipple
                            classes={{
                                root: classes.iconRoot,
                                switchBase: classes.switchBase,
                                thumb: classes.thumb,
                                track: classes.track,
                                checked: classes.checked,
                            }}
                        />
                    )}
                />
                {autoRenewal?.checked
                    ? (<span className={classes.greenText}>On</span>)
                    : (<span className={classes.redText}>Off</span>)}
            </div>
            {showModal && (
                <AutoRenewalModal
                    closeModal={closeModal}
                    open={showModal}
                    userDetails={userDetails}
                    setAutoRenewal={setAutoRenewal}
                    setShowModal={setShowModal}
                    updateAutoRenewal={updateAutoRenewal}
                    trackAutoRenewEvent={trackAutoRenewEvent}
                />
            )}
        </div>
    );
};

const mapDispatchToProps = (dispatch) => ({
    trackAutoRenewEvent: bindActionCreators(track, dispatch),
});

AutoRenewal.propTypes = {
    classes: object,
    userDetails: shape({
        renewalDate: string,
    }),
    updateAutoRenewal: func.isRequired,
    autoRenewalStatus: bool.isRequired,
    trackAutoRenewEvent: func.isRequired,
};

AutoRenewal.defaultProps = {
    classes: {},
    userDetails: {
        renewalDate: '',
    },
};

export default connect(null, mapDispatchToProps)(withStyles(styles)(AutoRenewal));
